import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/PromoPages.module.scss";
import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useEffect, useRef} from "react";
import CommonClass from "@/utils/common.ts";
import useCommon from "@/hooks/common.ts";
import LazyImage from "@/ui/LazyImage.tsx";
import Button from "@/ui/Button.tsx";


const Promotion = () => {
    const effect_ran = useRef<boolean>(false)
    const navigation = useNavigate()
    const common_hook = useCommon()
    const {t,  i18n} = useTranslation()
    const {api_id} = useParams()
    const local_prom_raw = CMS.getCabinetOffers().find((x:any) => x.api_id === api_id)
    const local_prom = CMS.langAwareFilter(local_prom_raw, (i18n.language as LocalLanguage))
    const {
        heading,
        main_image,
        date,
        upper_content,
        bottom_content,
        cta_text,
        cta_url
    } = local_prom

    const prom_end_date = CommonClass.days_till_prom_end(local_prom)
    const is_prom_end_data = Boolean(typeof prom_end_date === "object" && Object.keys(prom_end_date))

    useEffect(() => {
        if(!effect_ran.current) {
            if(!local_prom.cabinet_visible) {
                navigation(-1)
            }
        }
        
        return () => {
            effect_ran.current = true
        }
        
    }, []);
    
    return (
        <DashboardGenComponent
            header_type={"primary"}
            backFunction
            centered_content_expanded
            
            heading={
                <div className={st.heading}>
                    {(typeof heading === "string" && heading.length) ? (
                        <h2>
                            {heading}
                        </h2>
                    ) : null}
                    
                </div>
            }
            
            column_center={
                <div className={st.promo_column_center}>
                    {(Array.isArray(main_image) && main_image.length) ? (
                        <LazyImage className={st.img} src={CMS.getFilePath(main_image[0].path)} alt="" />
                    ) : null}
                    
                    {is_prom_end_data ? (
                        <>
                            
                            {(prom_end_date.days <= 0 && prom_end_date.hours <= 0) ? (
                                <div className={st.inf_brick}>
                                    <span>
                                        {t("expired_promo")}
                                    </span>
                                </div>
                            
                            ) : (
                                <div className={st.inf_brick}>
                                    {Object.entries(prom_end_date).map((unity, i) => {
                                        let key = unity[0]
                                        let val = unity[1] as number | string;
                                        
                                        return (
                                            
                                            <div key={`is_prom_end_data_key ${i}`} className={st.time_unity}>
                                                <strong>
                                                    {(typeof val !== undefined) && val}
                                                </strong>
                                                
                                                <span>
                                                    {t(key)}
                                                </span>
                                            </div>
                                        
                                        )
                                    })}
                                </div>
                            )}
                        </>
                    
                    ) : (
                        <div className={st.inf_brick}>
                            <strong>
                                {common_hook.formatMomentDate(date)}
                            </strong>
                        </div>
                    )}
                    
                    <div>
                        {upper_content && (
                            <div className={st.content} dangerouslySetInnerHTML={{__html:upper_content}} />
                        )}
                        
                        {bottom_content && (
                            <div className={st.content} dangerouslySetInnerHTML={{__html:bottom_content}} />
                        )}
                    </div>
                    
                    {(cta_text && cta_url) ? (
                        <Button
                            onClick={() => {
                                common_hook.smartNavigation(cta_url)
                            }}
                        >
                            {t("cta_promotion")}
                        </Button>
                    ) : null}
                    
                    
                </div>
            }

        />
    )
}

export default Promotion